const isRequired = () => { throw new Error('param is required'); };

export { isRequired }